<template>
<div class="workspace">
  <tabs class="w-term-tabs" @addNewSess="$emit('addNewSess')" />
  <sessions @close="focusCurTerm" />
  <ssh-known-hosts />
  <keys />
</div>
</template>

<script>
import tabs from './tab/tabs'
import Keys from './key/keys.vue';
import SshKnownHosts from "./knownHost/sshKnownHosts";
import Sessions from "./session/sessions";

export default {
  name: "workspace",
  components: {
    Sessions,
    SshKnownHosts,
    tabs,
    Keys,
  },
  methods: {
    focusCurTerm: function() {
      this.env.termFocusCurrent()
    },
  },
}
</script>

<style scoped>
.workspace {
  width: 100%;
  flex-grow: 1;

  display: flex;
  flex-direction: column;
}
.w-term-tabs {
  flex-grow: 1;
}
</style>
